"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * <SkipLink target={'#foo'} />
 */
var SkipLink =
/*#__PURE__*/
function (_Component) {
  _inherits(SkipLink, _Component);

  function SkipLink() {
    var _this;

    _classCallCheck(this, SkipLink);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SkipLink).call(this));
    _this.state = {
      currentClass: ''
    };
    _this.onClick = _this.onClick.bind(_assertThisInitialized(_this));
    _this.onFocus = _this.onFocus.bind(_assertThisInitialized(_this));
    _this.onBlur = _this.onBlur.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(SkipLink, [{
    key: "render",
    value: function render() {
      var currentClass = this.state.currentClass;
      var _this$props = this.props,
          target = _this$props.target,
          skipText = _this$props.skipText,
          targetText = _this$props.targetText;
      return _react["default"].createElement("nav", {
        className: (0, _classnames["default"])('dqpl-skip-container', currentClass)
      }, _react["default"].createElement("a", {
        href: target,
        className: "dqpl-skip-link",
        onClick: this.onClick,
        onFocus: this.onFocus,
        onBlur: this.onBlur
      }, _react["default"].createElement("span", {
        className: "dqpl-skip-one"
      }, skipText), _react["default"].createElement("span", {
        className: "dqpl-skip-two"
      }, targetText)));
    }
  }, {
    key: "onClick",
    value: function onClick() {
      var element = document.querySelector(this.props.target);

      if (element) {
        element.tabIndex = -1;
        element.focus();
      }
    }
  }, {
    key: "onFocus",
    value: function onFocus() {
      var _this2 = this;

      this.setState({
        currentClass: 'dqpl-skip-container-active'
      });
      setTimeout(function () {
        _this2.setState({
          currentClass: 'dqpl-skip-container-active dqpl-skip-fade'
        });
      });
    }
  }, {
    key: "onBlur",
    value: function onBlur() {
      var _this3 = this;

      this.setState({
        currentClass: 'dqpl-skip-container-active'
      });
      setTimeout(function () {
        _this3.setState({
          currentClass: ''
        });
      });
    }
  }]);

  return SkipLink;
}(_react.Component);

exports["default"] = SkipLink;
SkipLink.propTypes = {
  // enforce a valid id hash string (example: '#foo')
  target: function target(props, propName, componentName) {
    var value = props[propName];

    if (!value || typeof value !== 'string' || value[0] !== '#') {
      return new Error("Invalid prop ".concat(propName, " supplied to ").concat(componentName, " (must be string starting with \"#\")"));
    }
  },
  skipText: _propTypes["default"].string,
  targetText: _propTypes["default"].string
};
SkipLink.defaultProps = {
  skipText: 'Skip to',
  targetText: 'Main Content'
};